import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/auth/AuthContext';
import { Spinner } from '@/components/common/Spinner';

// Client-side convenience guard only. Backend authorization remains the real
// security boundary (every app-service call is [Authorize]-checked).
export function ProtectedRoute() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div className="d-flex min-vh-100 align-items-center justify-content-center">
        <Spinner label="Loading your session…" />
      </div>
    );
  }

  if (status === 'unauthenticated') {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
